// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createQuarantine,
  createRepairedQuarantine,
  deleteQuarantine,
  getDetailQuarantine,
  getListQuarantine,
  updateQuarantine,
} from '~/thunks/quarantine/quarantineThunk';

export interface IQuarantineState {
  isRefreshQuarantineList: boolean;
}

export const initialState: IQuarantineState = {
  isRefreshQuarantineList: false,
};

const quarantineSlice = createSlice({
  name: 'quarantine',
  initialState,
  reducers: {
    setRefreshQuarantineList(state, action) {
      state.isRefreshQuarantineList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list quarantine
    builder
      .addCase(getListQuarantine.pending, (_state) => {})
      .addCase(getListQuarantine.fulfilled, (_state) => {})
      .addCase(getListQuarantine.rejected, (_state) => {});

    // PUT: Create repaired quarantine
    builder
      .addCase(createRepairedQuarantine.pending, (_state) => {})
      .addCase(createRepairedQuarantine.fulfilled, (state) => {
        state.isRefreshQuarantineList = true;
      })
      .addCase(createRepairedQuarantine.rejected, (_state) => {});

    // DELETE: Delete quarantine
    builder
      .addCase(deleteQuarantine.pending, (_state) => {})
      .addCase(deleteQuarantine.fulfilled, (state) => {
        state.isRefreshQuarantineList = true;
      })
      .addCase(deleteQuarantine.rejected, (_state) => {});

    // POST: Create quarantine
    builder
      .addCase(createQuarantine.pending, (_state) => {})
      .addCase(createQuarantine.fulfilled, (state) => {
        state.isRefreshQuarantineList = true;
      })
      .addCase(createQuarantine.rejected, (_state) => {});

    // GET: Get detail quarantine
    builder
      .addCase(getDetailQuarantine.pending, (state) => {
        state.isRefreshQuarantineList = true;
      })
      .addCase(getDetailQuarantine.fulfilled, (state) => {
        state.isRefreshQuarantineList = false;
      })
      .addCase(getDetailQuarantine.rejected, (_state) => {});

    // POST: Update quarantine
    builder
      .addCase(updateQuarantine.pending, (_state) => {})
      .addCase(updateQuarantine.fulfilled, (state) => {
        state.isRefreshQuarantineList = true;
      })
      .addCase(updateQuarantine.rejected, (_state) => {});
  },
});

// Action
export const quarantineActions = quarantineSlice.actions;

// Selectors
export const selectIsRefreshListQuarantine = (state: RootState) => state.quarantine.isRefreshQuarantineList;

// Reducer
const quarantineReducer = quarantineSlice.reducer;
export default quarantineReducer;
